import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'
import type { TransferBalanceAmountCode } from '@api/mesa/graphql'
import type { ExternalAccount } from '@/src/common/components/fundingSourceSelector'

export interface LegacyAutoPayStore {
  paymentStrategy: { label: string; value: TransferBalanceAmountCode } | undefined
  day: { label: string; value: number } | undefined
  setPaymentStrategy: (
    paymentStrategy: { label: string; value: TransferBalanceAmountCode } | undefined,
  ) => void
  setDay: (date: { label: string; value: number } | undefined) => void
  account: ExternalAccount | undefined
  setAccount: (account: ExternalAccount | undefined) => void
  clear: () => void
}

export const useLegacyAutoPayStore = create(
  persist<LegacyAutoPayStore>(
    (set) => ({
      paymentStrategy: undefined,
      day: undefined,
      account: undefined,
      setPaymentStrategy: (paymentStrategy) => set({ paymentStrategy }),
      setDay: (day) => set({ day }),
      setAccount: (account) => set({ account }),
      clear: () => set({ paymentStrategy: undefined, day: undefined, account: undefined }),
    }),
    {
      name: 'legacy-auto-pay',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)
